const results = [
  { icon: 'ri-user-star-line', text: 'Более самостоятельные сотрудники, которые решают задачи в рамках своей ответственности' },
  { icon: 'ri-medal-line', text: 'Повышение качества работы за счёт освоения необходимых компетенций' },
  { icon: 'ri-radar-line', text: 'Развитие именно тех компетенций, которые влияют на результаты бизнеса' },
  { icon: 'ri-speed-up-line', text: 'Ускорение профессионального роста сотрудников' },
  { icon: 'ri-group-line', text: 'Снижение зависимости компании от отдельных сильных специалистов' },
  { icon: 'ri-vip-crown-line', text: 'Формирование кадрового резерва и подготовка будущих руководителей' },
  { icon: 'ri-user-add-line', text: 'Более эффективная адаптация новых сотрудников' },
  { icon: 'ri-exchange-line', text: 'Передача опыта внутри компании, а не его утрата при уходе сотрудников' },
  { icon: 'ri-dashboard-line', text: 'Повышение управляемости процесса развития сотрудников' },
  { icon: 'ri-links-line', text: 'Связь обучения с бизнес-задачами компании' },
  { icon: 'ri-list-check-2', text: 'Понятные критерии развития и оценки прогресса' },
  { icon: 'ri-seedling-line', text: 'Культура постоянного профессионального развития' },
];

export default function CompanyResults() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что получает компания
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Результат системного развития персонала проявляется не в абстрактных показателях, а в конкретных изменениях работы команды.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <div className="w-9 h-9 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${r.icon} text-teal-700`}></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}